/* Formula Sample Set builder (TEST THEME, Oct 31 2026). See sections/meera-sample-set-builder.liquid. */
(function () {
  document.querySelectorAll('[data-mss]').forEach(function (root) {
    var min = Number(root.getAttribute('data-min')) || 0;
    var fmt = root.getAttribute('data-money') || '${{amount}}';
    var copy = {};
    try { copy = JSON.parse(root.querySelector('[data-mss-copy]').textContent); } catch (e) {}
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mss-item]'));
    var bar = root.querySelector('[data-mss-bar]');
    var btn = root.querySelector('[data-mss-add]');
    var btnLabel = root.querySelector('[data-mss-btn-label]');
    var msg = root.querySelector('[data-mss-msg]');
    var fill = root.querySelector('[data-mss-fill]');
    var qty = {};
    var busy = false;
    var setKeys = [];      // cart line keys of the set already in the bag (edit mode)
    var inBag = '';        // snapshot of the set in the bag, to tell whether anything changed
    var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function snapshot() { return JSON.stringify(Object.keys(qty).sort().filter(function (k) { return qty[k] > 0; }).map(function (k) { return k + ':' + qty[k]; })); }

    // Store money format drops decimals; show cents only when there are some ($20, $22.50).
    // On /fr, Canadian French order: 20 $, 22,50 $.
    var fr = root.hasAttribute('data-fr');
    function money(cents) {
      var v = cents % 100 ? (cents / 100).toFixed(2) : String(cents / 100);
      if (fr) return v.replace('.', ',') + '\u00a0$';
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function () { return v; });
    }

    function totals() {
      var count = 0, cents = 0;
      items.forEach(function (li) {
        var q = qty[li.dataset.variant] || 0;
        count += q; cents += q * Number(li.dataset.price);
      });
      return { count: count, cents: cents };
    }

    function render(note) {
      var t = totals();
      items.forEach(function (li) {
        var q = qty[li.dataset.variant] || 0, max = Number(li.dataset.max);
        var out = li.querySelector('[data-mss-qty]'); if (out) out.textContent = q;
        var dec = li.querySelector('[data-mss-dec]'); if (dec) dec.disabled = q <= 0;
        var inc = li.querySelector('[data-mss-inc]'); if (inc) inc.disabled = q >= max;
        li.classList.toggle('is-picked', q > 0);
      });
      root.querySelector('[data-mss-count]').textContent = t.count;
      var unit = root.querySelector('[data-mss-unit]');
      if (unit) unit.textContent = t.count === 1 ? unit.getAttribute('data-one') : unit.getAttribute('data-many');
      root.querySelector('[data-mss-total]').textContent = money(t.cents);
      var ok = t.cents >= min && t.count > 0;
      var unchanged = setKeys.length && snapshot() === inBag;
      btnLabel.textContent = busy ? (copy.adding || '…') : (setKeys.length ? (copy.update || copy.button) : copy.button);
      if (unchanged) ok = false;
      fill.style.width = (min > 0 ? Math.min(100, (t.cents / min) * 100) : (t.count ? 100 : 0)) + '%';
      bar.classList.toggle('is-ready', ok);
      btn.disabled = !ok || busy;
      if (note) msg.textContent = note;
      else if (!t.count) msg.textContent = copy.start || '';
      else if (unchanged) msg.textContent = copy.inbag || '';
      else if (t.cents < min) msg.textContent = (copy.more || '').replace('[amount]', money(min - t.cents));
      else msg.textContent = copy.ready || '';
    }

    root.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-mss-inc]'), dec = e.target.closest('[data-mss-dec]');
      if (!inc && !dec) return;
      var li = e.target.closest('[data-mss-item]'); var id = li.dataset.variant;
      var q = qty[id] || 0, max = Number(li.dataset.max);
      qty[id] = inc ? Math.min(max, q + 1) : Math.max(0, q - 1);
      render();
    });

    function drawerSections() {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.getSectionsToRender === 'function') return d.getSectionsToRender().map(function (s) { return s.id; });
      return [];
    }

    btn.addEventListener('click', function () {
      var t = totals();
      if (busy || t.cents < min || !t.count) return;
      var lines = items.filter(function (li) { return (qty[li.dataset.variant] || 0) > 0; }).map(function (li) {
        return { id: Number(li.dataset.variant), quantity: qty[li.dataset.variant], properties: { _sample_set: '1' } };
      });
      busy = true; btn.disabled = true; btnLabel.textContent = copy.adding || '…';
      var sections = drawerSections();
      var clear = {};
      setKeys.forEach(function (k) { clear[k] = 0; });
      var pre = setKeys.length
        ? fetch(root_ + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: clear }) })
        : Promise.resolve();
      pre.then(function () { return fetch(root_ + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines, sections: sections, sections_url: window.location.pathname })
      }); })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (state) {
          var d = document.querySelector('cart-drawer');
          if (d && state.sections && typeof d.renderContents === 'function') {
            d.renderContents(state);
            if (typeof d.open === 'function') d.open(btn);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sample-set' });
          document.dispatchEvent(new CustomEvent('cart:updated'));
          busy = false;
          return loadFromCart().then(function () { render(copy.added); });
        })
        .catch(function (err) {
          console.error('[sample-set]', err);
          busy = false; btnLabel.textContent = copy.button || '';
          render((err && (err.description || err.message)) || copy.error);
        });
    });

    // Mirror the set already in the bag, so the builder edits it instead of adding a second one.
    function loadFromCart() {
      return fetch(root_ + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ids = {}; items.forEach(function (li) { ids[li.dataset.variant] = true; });
          qty = {}; setKeys = [];
          cart.items.forEach(function (i) {
            if (!(i.properties && i.properties._sample_set)) return;
            setKeys.push(i.key);
            if (ids[i.variant_id]) qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity;
          });
          inBag = setKeys.length ? snapshot() : '';
        })
        .catch(function () {});
    }

    render();
    loadFromCart().then(function () { render(); });
    document.addEventListener('cart:updated', function () { if (!busy) loadFromCart().then(function () { render(); }); });
  });
})();
